module.exports = __webpack_public_path__ + "img/pc_crash.8d8f0faa.png";